module.exports = __webpack_public_path__ + "img/qrcode_wechat.d7ee92c9.png";